import classNames from 'classnames';
import { FormattedMessage } from 'react-intl';
import { useCheckoutState } from '../../../utils/checkoutState';
import { getAssetUrl } from '../../../utils/config';
import useSlotClickEvent from '../../../utils/useSlotClickEvent';
import Button from '../../atoms/Button';
import Collapse from '../../atoms/Collapse';
import FormattedAddress from '../../atoms/FormattedAddress';
import AddressOverviewForm from './AddressOverviewForm';
import './style.scss';

type AddressOverviewProps = {
  addressType: 'billing' | 'shipping';
  showTitle?: boolean;
  onChangeClick?: () => void;
  navigateToCp?: () => void;
  showAddressForm?: boolean;
  isEditingAddress?: boolean;
  setEditingAddress?: (isEditingAddress: boolean) => void;
};

const AddressOverview = ({
  addressType,
  showTitle,
  navigateToCp,
  onChangeClick,
  showAddressForm,
  isEditingAddress,
  setEditingAddress
}: AddressOverviewProps) => {
  const { checkoutState, isLoading } = useCheckoutState();
  useSlotClickEvent('slot_suggest_collection_point', navigateToCp, !navigateToCp);

  const hasShippingAddress = !!checkoutState.orderState.addresses!.shipping!;

  return (
    <>
      <div
        className={classNames('address-overview', {
          'address-overview--cp': navigateToCp,
          'address-overview-form': isEditingAddress
        })}
        data-test-id="address-overview"
      >
        {!isEditingAddress && (
          <Button
            className="address-overview__btn"
            disabled={!!isLoading}
            onClick={showAddressForm ? () => setEditingAddress?.(!isEditingAddress) : onChangeClick}
            data-test-id="address-overview_change-btn"
          >
            <FormattedMessage id="generic.change" />
          </Button>
        )}

        {hasShippingAddress && !isEditingAddress && (
          <FormattedAddress
            address={
              addressType === 'shipping' ?
                checkoutState.orderState.addresses!.shipping!
              : checkoutState.orderState.addresses!.billing!
            }
            title={
              showTitle && (
                <dt className="address-overview__title">
                  <FormattedMessage id={`address.${addressType}Address`} />
                </dt>
              )
            }
          />
        )}
        {showAddressForm && (
          <Collapse isOpen={isEditingAddress!}>
            <AddressOverviewForm setEditingAddress={setEditingAddress!} isEditingAddress={isEditingAddress!} />
          </Collapse>
        )}
      </div>
      {navigateToCp && (
        <div
          className={classNames('address-overview__cp-suggestion', { 'cursor-disabled': !!isLoading })}
          onClick={() => !isLoading && navigateToCp!()}
          data-test-id="cp-suggestion"
        >
          <div>
            <img
              className="address-overview__icon"
              src={getAssetUrl('delivery/collectionPoint.svg')}
              alt="Collection Points Icon"
            />
            <FormattedMessage id="address.selectCollectionPoint" />
          </div>
          <slot name="slot_suggest_collection_point" />
        </div>
      )}
    </>
  );
};

export default AddressOverview;
